import { Campaign } from '../../../../api/campaign/types'

export enum ImportStep {
	CREATE_CAMPAIGN = 'create',
	UPLOAD_LEADS = 'upload',
	SETUP_CAMPAIGN = 'setup',
	RUN_CAMPAIGN = 'run',
}

export type CampaignPayload = {
	campaignId: string
	retryCampaign: boolean
	agentId?: string
	testPhoneNumber?: string
}

export type ImportData = {
	selectedCampaign: Campaign
	campaignPayload: CampaignPayload
}

export type CampaignsState = {
	importStep: ImportStep[keyof ImportStep]
	importData: ImportData
}
